import React from 'react';
import {Modal, Button, Alert} from 'react-bootstrap';

interface Member {
  id: number;
  email: string;
}

interface DeleteMemberModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  member: Member | null;
  mailingListAddress?: string;
}

const DeleteMemberModal: React.FC<DeleteMemberModalProps> = ({
  show,
  onHide,
  onConfirm,
  member,
  mailingListAddress,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  if (!member) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa-solid fa-triangle-exclamation text-warning me-2"></i>
          Confirmer la suppression
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          Êtes-vous sûr de vouloir retirer ce membre de la liste de diffusion ?
        </p>

        <Alert variant="secondary" className="border">
          <div className="d-flex align-items-center">
            <i className="fa-solid fa-user fs-3 text-primary me-3"></i>
            <div>
              <strong className="d-block text-dark">{member.email}</strong>
              {mailingListAddress && (
                <small className="text-dark">
                  Liste : {mailingListAddress}
                </small>
              )}
            </div>
          </div>
        </Alert>

        <Alert variant="warning" className="mb-0 bg-warning bg-opacity-25 text-dark">
          <i className="fa-solid fa-exclamation-triangle me-2 text-warning"></i>
          <strong>Attention :</strong> Ce membre ne recevra plus les emails envoyés à cette liste de diffusion.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          <i className="fa-solid fa-times me-2"></i>
          Annuler
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          <i className="fa-solid fa-trash me-2"></i>
          Retirer de la liste
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteMemberModal;
